// src/components/ProgramList.jsx
import React from 'react';
import ProgramCard from './ProgramCard';

/**
 * ProgramList
 * Displays a grid of program cards
 * Uses mwc-layout.css for grid styling
 */
export default function ProgramList({ programs = [] }) {
  if (!programs || programs.length === 0) {
    return (
      <div className="mwc-results-empty">
        <div className="mwc-results-empty__icon">🎓</div>
        <p className="mwc-results-empty__text">
          No programs found
        </p>
      </div>
    );
  }

  return (
    <div className="mwc-results-programs__grid">
      {programs.map((program, index) => (
        <ProgramCard 
          key={program._id || program.id || `program-${index}`} 
          program={program} 
        />
      ))}
    </div>
  );
}